var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"basic-map",attrs:{"id":"mapContainer"}},[_c('div',{ref:"pointPopup",staticClass:"point-popup"},[_vm._t("pointPopup",null,{"data":_vm.activePointInfo})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }